import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';

import { environment } from '../../../../environments/environment';

/**
 * Full-screen notice shown on viewports below the tablet breakpoint.
 * Drop `<app-mobile-unsupported />` at the app root (or any layout) and
 * hide desktop chrome with the `.desktop-only` utility while mobile is active.
 */
@Component({
    selector: 'app-mobile-unsupported',
    standalone: true,
    imports: [TranslocoDirective],
    templateUrl: './mobile-unsupported.component.html',
    styleUrl: './mobile-unsupported.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        role: 'dialog',
        'aria-modal': 'true',
        'aria-labelledby': 'mobile-unsupported-title',
        'aria-describedby': 'mobile-unsupported-message',
    },
})
export class MobileUnsupportedComponent {
    /** AST product branding — never the customer's uploaded company logo. */
    protected readonly brandLogoUrl = environment.defaultLogoUrl;
}
